import Site from './Site';

export default class SiteAUS extends Site {
  constructor () {
    super();
    this.currencyCode = 'AUD';
    this.shortWeight = 'kg';
    this.siteCode = 'AUS';
    this.maxGoalValue = 80;
    this.minimumBetValue = 300;
    this.convertionRate = 1.674;
    this.siteName = 'Australia';
    this.moneyText = 'Australian Dollars'
  }

  useSI() {
    return true;
  }

  convertedGoal() {
    return this.convertWeightToKg(34);
  }
}
